/*
 * chat-dismiss.js — the Shopify Inbox «Συνομιλία» button, kept out of the way.
 *
 * Stelios, 08/10/2026: «Εμφανίζεται συνέχεια σε λάθος σημεία. Ίσως ένα "x" για να μπορεί να το κλείνει.»
 *   - A small × at the button's corner hides the chat for the rest of the visit (sessionStorage), on every page.
 *   - It is not shown while a drawer or a modal is open: Dawn puts `overflow-hidden…` on <body> then
 *     (assets/base.css), and on the wish card's page at all, where the card takes the screen
 *     (sections/main-card.liquid).
 *
 * The button lives two OPEN shadow roots deep — shopify-chat → shopify-agent-runtime → button.activator — so the ×
 * is a light-DOM button laid over its corner, placed from the activator's own rectangle (whatever position the
 * app's settings give it), and hidden whenever the chat's panel is open or the activator is not on screen. If the
 * app changes its markup, the × simply never appears: nothing else depends on it.
 */
(() => {
  'use strict';
  const KEY = 'mb-chat-off';
  const html = document.documentElement;
  let off = false;
  try { off = sessionStorage.getItem(KEY) === '1'; } catch (e) { off = false; }   // a private window may refuse storage
  if (off) { html.classList.add('mb-chat-off'); return; }

  let x = null;
  function parts() {
    const host = document.querySelector('shopify-chat');
    const rt = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    const sr = rt && rt.shadowRoot;
    return sr ? { host, btn: sr.querySelector('button.activator'), panel: sr.querySelector('.panel') } : null;
  }
  function hideX() { if (x) x.hidden = true; }
  function close() {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* the class below still hides it on this page */ }
    html.classList.add('mb-chat-off');
    hideX();
    clearInterval(timer);
  }
  function place() {
    if (html.classList.contains('mb-chat-off')) { hideX(); return; }
    const p = parts();
    if (!p || !p.btn || getComputedStyle(p.host).display === 'none') { hideX(); return; }
    const r = p.btn.getBoundingClientRect(), pr = p.panel && p.panel.getBoundingClientRect();
    if (!r.width || !r.height || (pr && pr.width > 0 && pr.height > 0)) { hideX(); return; }   // not on screen, or the chat is open
    if (!x) {
      x = document.createElement('button');
      x.type = 'button';
      x.className = 'mb-chat-x';
      x.setAttribute('aria-label', 'Κλείσε το κουμπί της συνομιλίας');
      x.innerHTML = '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>';
      x.addEventListener('click', close);
      document.body.appendChild(x);
    }
    x.hidden = false;
    const atRight = r.left + r.width / 2 > window.innerWidth / 2;   // the corner towards the page: the button sits at a screen edge
    x.style.left = Math.round(atRight ? r.left - 12 : r.right - 16) + 'px';
    x.style.top = Math.round(r.top - 12) + 'px';
  }
  // the app draws its button late and animates it in; a light poll costs two rectangles a second — and nothing in a
  // tab that is not on screen (go-live review D11)
  const timer = setInterval(() => { if (!document.hidden) place(); }, 500);
  window.addEventListener('resize', place, { passive: true });
})();
